import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getCustomerTitles = createAsyncThunk(
  '/getCustomerTitles',
  async () => {
    const response = await axios.get('/GetCustomerTitles');
    return response.data;
  }
);

export const getCustomerTitleDetails = createAsyncThunk(
  '/getCustomerTitleDetails',
  async (id) => {
    const response = await axios.get(`/GetCustomerTitleDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const customerTitleSlice = createSlice({
  name: 'customerTitles',
  initialState: {
    loading: false,
    error: '',
    CustomerTitles: [],
    CustomerTitleDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.CustomerTitleDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },

  extraReducers: {
    [getCustomerTitles.pending]: (state) => {
      state.loading = true;
    },
    [getCustomerTitles.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCustomerTitles.fulfilled]: (state, action) => {
      state.CustomerTitles = action.payload;
      state.loading = false;
    },
    [getCustomerTitleDetails.pending]: (state) => {
      state.loading = true;
    },
    [getCustomerTitleDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCustomerTitleDetails.fulfilled]: (state, action) => {
      state.CustomerTitleDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.CustomerTitleDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const customerTitleActions = customerTitleSlice.actions;

export default customerTitleSlice;
